import React from 'react'
import PropTypes from 'prop-types'

import BasicViewComponent from './BasicViewComponent'
import View from './View'

class CompositeVertical extends BasicViewComponent {

  constructor (props) {
    super(props)

    this.contents = this.props.config.contents
    this.keyPrefix = Math.random().toString(36).substr(2, 5)
  }

  render () {
    if (!super.conditionsAreMet()) {
      return null
    }

    let contents = []
    this.contents.forEach((view, index) => {
      if (View.conditionsAreMet(view, this.props.functions, this.props.poi)) {
        contents.push(
          <View
            key={`${this.keyPrefix}-${index}`}
            config={view}
            functions={this.props.functions}
            poi={this.props.poi}
            filterSettings={this.props.filterSettings}
            setCategoryVisible={this.props.setCategoryVisible}
            setSelectedCountry={this.props.setSelectedCountry}
          />
        )
      }
    })

    if (!this.props.config.hasOwnProperty('useBr') || this.props.config.useBr) {
      // add a <br /> between all content elements
      let i = contents.length
      contents = contents.reduce((acc, val) => {
        const acc2 = acc
        if (acc.length > 0) {
          acc2.push(<br key={`${this.keyPrefix}-br-${i++}`} />)
        }
        acc2.push(val)
        return acc2
      }, [])
    }

    return (
      <span className={this.cssClass}>
        {contents}
      </span>
    )
  }
}

CompositeVertical.TYPE = 'composite_vertical'

CompositeVertical.propTypes = {
  config: PropTypes.object.isRequired,
  functions: PropTypes.object,
  poi: PropTypes.object,
  filterSettings: PropTypes.object,
  setCategoryVisible: PropTypes.func,
  setSelectedCountry: PropTypes.func,
}

export default CompositeVertical



// WEBPACK FOOTER //
// ./src/components/ViewComponents/CompositeVertical.js